import { createContext, useCallback, useContext, useMemo } from "react";
import { useAuth } from "../components/contexts/AuthContext";
import { getUserFirstLast } from "../api/auth";

const UserContext = createContext(null);

// Exposes the authenticated user's identity (already fetched via
// getUserFirstLast in AuthProvider on landing) in a destructurable shape:
//   const { first_name, fullName, email } = useUserContext();
export function UserProvider({ children }) {
  const { user, setUser } = useAuth();

  const refreshUser = useCallback(async () => {
    const response = await getUserFirstLast();
    const data = response?.data || null;
    setUser(data);
    return data;
  }, [setUser]);

  const value = useMemo(() => {
    const first_name = user?.first_name || "";
    const last_name = user?.last_name || "";

    return {
      user,
      first_name,
      last_name,
      first_initial:
        user?.first_initial || first_name.charAt(0).toUpperCase(),
      last_initial: user?.last_initial || last_name.charAt(0).toUpperCase(),
      email: user?.email || "",
      fullName: [first_name, last_name].filter(Boolean).join(" "),
      refreshUser,
    };
  }, [user, refreshUser]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
}
